import { Outlet, useOutletContext } from 'react-router-dom';
import { MarketLayoutOutletContext } from '@/enterprise/components/MarketRedirect';
import Skeleton from '@/enterprise/components/Skeleton';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import { MarketPendingClearsAlert } from '@/enterprise/features/history/PendingClearsAlert';
import QueryBoundaries from '@/shared/components/QueryBoundaries';

export interface MarketHistoryLayoutOutletContext {
  readonly takerMarket: TakerMarket;
  readonly urlParams: {
    marketId: string;
    takerId: number;
  };
}

export function useMarketHistoryLayoutOutletContext() {
  return useOutletContext<MarketHistoryLayoutOutletContext>();
}

const MarketHistoryLayoutComponent = () => {
  const marketContext = useOutletContext<MarketLayoutOutletContext>();
  return (
    <>
      {marketContext && (
        <MarketPendingClearsAlert
          takerUuid={marketContext.takerMarket.takerDivisionUuid}
          marketUuid={marketContext.takerMarket.marketUuid}
          makerOrganizationUuid={marketContext.takerMarket.makerOrganizationUuid}
        />
      )}
      <div className="rounded-md bg-white shadow-md">
        <Outlet
          {...(marketContext && {
            context: {
              takerMarket: marketContext.takerMarket,
              urlParams: {
                marketId: marketContext.urlParams.marketId,
                takerId: marketContext.urlParams.takerId,
              },
            } satisfies MarketHistoryLayoutOutletContext,
          })}
        />
      </div>
    </>
  );
};

const MarketHistoryLayout = () => {
  return (
    <QueryBoundaries
      LoadingComponent={() => (
        <div className="space-y-6 rounded-md bg-gray-100 p-4">
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-80 w-full" />
        </div>
      )}
    >
      <MarketHistoryLayoutComponent />
    </QueryBoundaries>
  );
};

export default MarketHistoryLayout;
